module.exports = __webpack_public_path__ + "media/images/header-pdf-templates-b8831e6158e25865c0750df6aa34c838.svg";